<template>
    <div class="mb-8 flex flex-wrap p-8">
        <div class="lg:w-1/2 w-full pb-10">
            <table>
                <tr>
                    <td class="py-1 font-bold">Ämnesrad</td>
                    <td class="py-1">{{ reminder.subject }}</td>
                </tr>
                <tr>
                    <td class="py-1 font-bold">Underrubrik</td>
                    <td class="py-1">{{ stripTags(reminder.preheader) }}</td>
                </tr>
                <tr>
                    <td class="py-1 pr-6 font-bold">Datum för utskicket</td>
                    <td class="py-1">{{ reminder.send_date }}</td>
                </tr>
                <tr>
                    <td class="py-1 font-bold">Valda regioner</td>
                    <td class="py-1">{{ selected_regions }}</td>
                </tr>
                <tr>
                    <td class="py-1 font-bold">Valda produkter</td>
                    <td class="py-1">{{ selected_products }}</td>
                </tr>
                <tr>
                    <td class="py-1 font-bold">Valda roller</td>
                    <td class="py-1">{{ selected_roles }}</td>
                </tr>
            </table>
        </div>
        <div class="lg:w-1/2 w-full pb-10 text-right">
            <a :href="`/reminders/${reminder.id}/edit`" class="btn-cta mr-[15px]">Tillbaka till redigering</a>
            <a :href="`/reminders/${reminder.id}/preview/pdf`" class="btn-download-pdf">
                <Icon name="pdf" class="w-4 h-4 mr-2" />
                <span>Ladda ner som pdf</span>
            </a>
        </div>
        <div class="lg:w-1/1 w-full pb-10">
            <iframe ref="mailPreviewIframe" style="width:100%" :src="`/reminders/preview-mailable/${reminder.id}/${order_id}`"></iframe>
        </div>
        <div class="w-full pb-10 text-right">
            <a :href="`/reminders/${reminder.id}/edit`" class="btn-cta mr-[15px]">Tillbaka till redigering</a>
            <a :href="`/reminders/${reminder.id}/preview/pdf`" class="btn-download-pdf">
                <Icon name="pdf" class="w-4 h-4 mr-2" />
                <span>Ladda ner som pdf</span>
            </a>
        </div>
    </div>
</template>

<script>
    import { onMounted, ref } from 'vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import Icon           from '@/Shared/Icon'
    import Layout         from '@/Shared/Layout'

    export default {
        components: {
            Head,
            Icon,
            Link,
        },
        layout: Layout,
        props: {
            reminder: Object,
            order_id: Number,
            selected_regions: String,
            selected_products: String,
            selected_roles: String,
        },
        data() {
            return {}
        },
        methods: {
            stripTags(text) {
                let regex = /(<([^>]+)>)/ig;
                return text.replace(regex, "");
            }
        },
        setup() {
            const mailPreviewIframe = ref(null);

            onMounted(() => {
                setTimeout(() => {
                    mailPreviewIframe.value.style.height = mailPreviewIframe.value.contentWindow.document.body.scrollHeight + 'px';
                }, 2500)
            })

            return {
                mailPreviewIframe
            }
        },
        
    }
</script>